import { cn } from "../lib/utils";
import * as React from "react";
function LoadingBlock({ className, ...props }) {
    return (React.createElement("div", { className: cn("s-animate-opacity-pulse s-rounded-md", "s-bg-muted dark:s-bg-muted-background-night", className), ...props }));
}
export { LoadingBlock };
//# sourceMappingURL=LoadingBlock.js.map